import React, {Component} from 'react';
import DropZone from 'react-dropzone'

export default class DndItem extends Component {

    render() {
        return <DropZone className="dropzone" ref={(node) => { this.dropzone = node; }} onDrop={this.props.onDrop} >
                <div className="drag-title">DRAG AND DROP YOUR SUPPORTING DOCUMENT HERE</div>
                <button className="choose-file">Choose File</button>
            </DropZone>
    }

};


// WEBPACK FOOTER //
// ./src/components/common/DndItem.jsx